import React from 'react';
import { ArrowUpRight, X } from 'lucide-react';

const links = [
  { label: 'Products', href: '/products' },
  { label: 'Deals & Practices', href: '/deals' },
  { label: 'Sovereignty', href: '/#sovereignty' },
];

// Full-screen mobile navigation drawer (light theme, matching the landing page).
export const MobileDrawer = ({ open, onClose, onOpenBriefing }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-white flex flex-col justify-between p-6 sm:p-8 overflow-y-auto font-sans text-slate-900">
      <div>
        <div className="flex items-center justify-between pb-6 border-b border-slate-200 mb-2">
          <a href="/" className="font-extrabold tracking-[0.26em] text-slate-900 text-lg uppercase">FRONTIER</a>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-900 p-2 rounded-full bg-slate-100 transition">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="flex flex-col">
          {links.map((l) => (
            <a key={l.label} href={l.href} onClick={onClose} className="text-left text-base font-semibold text-slate-800 hover:text-[#F58220] py-4 border-b border-slate-100 transition">{l.label}</a>
          ))}
          <a href="/company" onClick={onClose} className="text-left text-base font-semibold text-slate-800 hover:text-[#F58220] py-4 border-b border-slate-100 transition">Company</a>
        </div>
      </div>
      <div className="pt-6">
        <button onClick={() => { onClose(); onOpenBriefing(); }} className="w-full py-3.5 rounded-full text-sm font-bold bg-[#090E1A] text-white hover:bg-black transition flex items-center justify-center gap-2">
          <span>Request Briefing</span>
          <ArrowUpRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
